import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiCall } from '../../utils/makeApiCall';
import { serializeError } from '../../utils/errorHandling';

// Get the Subscription of the User
export const getSubscriptionStatus = createAsyncThunk(
  'subscription/status',
  async (_, { rejectWithValue }) => {
    try {
      return await makeApiCall({
        url: '/subscriptions/status',
        method: 'GET',
      });
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);
